import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { rejectApprovalRequest } from '~/services/LuxLoyaltyService';

import { claimsQueryKeys } from './claimsQueryKeys';

export function useRejectRequest(campaignId: string) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: ({ requestId, notes }: { requestId: string; notes: string }) =>
      rejectApprovalRequest(requestId, { notes }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: claimsQueryKeys.approvalRequestsBase(campaignId) });
      enqueueSnackbar('Request rejected successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error rejecting request: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
